import React, { useEffect } from 'react';

import { ContainerHeader } from '~components';
import { faMoneyBill } from '~components/icon';
import { setTitle } from '~main/actions/login';
import { ConnectionManager } from '~direct-debits/components/connection';

const DirectDebitsContainer: React.FC = () => {
  useEffect(() => {
    setTitle('Direct Debits - GoCardless');
  }, []);

  return (
    <div className="p-2">
      <ContainerHeader icon={faMoneyBill} iconSize="1x" className="info" dataCy="direct-debits-header">
        Direct Debits — GoCardless
      </ContainerHeader>
      <ConnectionManager />
    </div>
  );
};

export default DirectDebitsContainer;
